module.exports = __webpack_public_path__ + "static/media/polygon.86fba126.svg";